import { getPreference } from '@webapp-next/lib/request/webapp/user/preferences';

export default async function peopleListColumnSettingsGet() {
  let data;
  try {
    data = await getPreference('TeamListShowFieldsSettings');
    data = data || {};

    return {
      success: true,
      message: typeof data === 'string' ? data : '',
      data: typeof data === 'string' ? {} : data,
    };
  } catch (e) {
    if (code === 404) {
      return false;
    }

    console.error(e);
    return {};
  }
}
